import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { LetterheadModel } from 'src/app/models/letterhead.model';
import { DialogService } from 'src/app/services/dialog.service';
import { LetterheadService } from 'src/app/services/letterhead.service';
import { TextControlService } from 'src/app/services/text-control.service';

@Component({
  selector: 'tx-section-letterhead',
  templateUrl: './section-letterhead.component.html',
  styleUrl: './section-letterhead.component.scss'
})
export class SectionLetterheadComponent implements OnInit {

  letterheadExists: boolean;

  constructor(private letterheadService: LetterheadService, private textControlService: TextControlService,
    private dialogService: DialogService
  ) {
    this.letterheadExists = false;
  }

  ngOnInit(): void {
    this.checkIfLetterheadExists();
  }

  onInsertLetterheadClicked() {
    this.letterheadService.getLetterhead()
    .pipe(take(1))
    .subscribe((res: LetterheadModel) => {
      this.textControlService.insertLetterhead(res).then((res: boolean) => {
        if (res === false) {
          this.dialogService.info({
            title: `No letterhead available`,
            message: 'You can configure a letterhead in the Letters section of the TXdocs Format Wizard.',
          });
        }
      });
    })
  }

  private checkIfLetterheadExists() {
    this.letterheadService.checkIfLetterheadExists()
    .pipe(take(1))
    .subscribe((res: boolean) => {
      this.letterheadExists = res;
    })
  }

}
